import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap text-sm text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors duration-200">
            <i className="ri-home-4-line text-sm mr-1"></i>
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center">
            <i className="ri-arrow-right-s-line text-xs mx-1.5 text-foreground-400"></i>
            {item.path && index < items.length - 1 ? (
              <Link to={item.path} className="hover:text-primary-500 transition-colors duration-200">
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}